import React, { useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import {
  FaBars,
  FaBriefcase,
  FaCalendarAlt,
  FaChevronDown,
  FaHome,
  FaImages,
  FaNewspaper,
  FaSignOutAlt,
  FaUserGraduate,
  FaFileAlt,
  FaHeart,
  FaEnvelope,
} from "react-icons/fa";
import styles from "./Layout.module.css";

const sidebarItems = [
  {
    label: "Dashboard",
    icon: FaHome,
    to: "/admin",
  },
  {
    label: "Careers",
    icon: FaBriefcase,
    children: [
      { label: "Add Career Job", to: "/admin/careers/add" },
      { label: "View Career Jobs", to: "/admin/careers" },
      { label: "Career Applicants", to: "/admin/career-applicants" },
    ],
  },
  {
    label: "Internships",
    icon: FaUserGraduate,
    children: [
      // { label: "Add Internship", to: "/admin/internships/add" },
      // { label: "View Internships", to: "/admin/internships" },
      { label: "View Applicants", to: "/admin/internship-applicants" },
    ],
  },
  {
    label: "Blogs",
    icon: FaNewspaper,
    children: [
      { label: "Add Blog", to: "/admin/blogs/add" },
      { label: "View Blogs", to: "/admin/blogs" },
    ],
  },
  {
    label: "Events",
    icon: FaCalendarAlt,
    children: [
      { label: "Add Event", to: "/admin/events/add" },
      { label: "View Events", to: "/admin/events" },
    ],
  },
  {
    label: "Photo Gallery",
    icon: FaImages,
    children: [
      { label: "Add Gallery Item", to: "/admin/gallery/add" },
      { label: "View Gallery", to: "/admin/gallery" },
    ],
  },
  {
    label: "Reports",
    icon: FaFileAlt,
    children: [
      // { label: "Audit Reports", to: "/admin/reports/audit" },
      { label: "Annual Reports", to: "/admin/reports/annual" },
    ],
  },
  // {
  //   label: "SEO Management",
  //   icon: FaSearch,
  //   to: "/admin/seo",
  // },
  {
    label: "Bank Details",
    icon: FaFileAlt,
    children: [
      { label: "Add Bank Details", to: "/admin/bank-details/add" },
      { label: "View Bank Details", to: "/admin/bank-details" },
    ],
  },
  {
    label: "Donations",
    icon: FaHeart,
    to: "/admin/donations",
  },
  {
    label: "Contact Messages",
    icon: FaEnvelope,
    to: "/admin/contact-messages",
  },
];

export default function AdminLayout() {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [openMenus, setOpenMenus] = useState(["Dashboard"]);
  const navigate = useNavigate();

  function logout() {
    localStorage.removeItem("adminToken");
    localStorage.removeItem("adminEmail");
    navigate("/admin/login");
  }

  function toggleMenu(label) {
    if (isCollapsed) return;
    setOpenMenus((current) =>
      current.includes(label)
        ? current.filter((item) => item !== label)
        : [...current, label]
    );
  }

  return (
    <div className={`${styles.wrapper} ${isCollapsed ? styles.collapsed : ""}`}>
      <aside className={`${styles.sidebar} ${isCollapsed ? styles.sidebarCollapsed : ""}`}>
        <div className={styles.brandWrap}>
          <div className={styles.brandMark}>V</div>
          {!isCollapsed && (
            <div className={styles.brandText}>
              <div className={styles.brandTitle}>Vikash Admin</div>
              <div className={styles.brandTag}>Premium Dashboard</div>
            </div>
          )}
          <button
            type="button"
            className={styles.collapseToggle}
            onClick={() => setIsCollapsed((value) => !value)}
            aria-label="Toggle sidebar"
          >
            <FaBars />
          </button>
        </div>

        <nav className={styles.nav}>
          {sidebarItems.map((item) => {
            const Icon = item.icon;
            const hasChildren = Array.isArray(item.children) && item.children.length > 0;
            const isOpen = openMenus.includes(item.label);
            const labelProps = isCollapsed ? { title: item.label } : {};

            return (
              <div key={item.label} className={styles.navItem}>
                {hasChildren ? (
                  <>
                    <button
                      type="button"
                      className={`${styles.navLink} ${isOpen ? styles.active : ""}`}
                      onClick={() => toggleMenu(item.label)}
                      {...labelProps}
                    >
                      <span className={styles.navIcon}>
                        <Icon />
                      </span>
                      {!isCollapsed && <span className={styles.linkText}>{item.label}</span>}
                      {!isCollapsed && (
                        <span className={`${styles.chevron} ${isOpen ? styles.open : ""}`}>
                          <FaChevronDown />
                        </span>
                      )}
                    </button>
                    <div className={`${styles.submenu} ${isOpen && !isCollapsed ? styles.open : ""}`}>
                      {item.children.map((child) => (
                        <NavLink
                          key={child.label}
                          to={child.to}
                          className={({ isActive }) =>
                            isActive ? `${styles.submenuItem} ${styles.active}` : styles.submenuItem
                          }
                        >
                          {child.label}
                        </NavLink>
                      ))}
                    </div>
                  </>
                ) : (
                  <NavLink
                    to={item.to}
                    className={({ isActive }) => (isActive ? `${styles.navLink} ${styles.active}` : styles.navLink)}
                    {...labelProps}
                  >
                    <span className={styles.navIcon}>
                      <Icon />
                    </span>
                    {!isCollapsed && <span className={styles.linkText}>{item.label}</span>}
                  </NavLink>
                )}
                {isCollapsed && <span className={styles.tooltip}>{item.label}</span>}
              </div>
            );
          })}
        </nav>

        <div className={styles.sidebarFooter}>
          <button className={styles.logout} onClick={logout} type="button">
            <span className={styles.navIcon}>
              <FaSignOutAlt />
            </span>
            {!isCollapsed && "Logout"}
          </button>
        </div>
      </aside>

      <div className={styles.mainArea}>
        <header className={styles.topbar}>
          <button
            type="button"
            className={styles.mobileMenuBtn}
            onClick={() => setIsCollapsed((value) => !value)}
            aria-label="Toggle menu"
          >
            <FaBars />
          </button>

          <div className={styles.topbarTitle}>
            <span className={styles.topbarTitleText}>Vikash Admin</span>
          </div>
        </header>

        <main className={styles.content}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
